module.exports = __webpack_public_path__ + "media/images/image-ad1edba28587d2f4f16e27eff9573746.png";